import { allImages } from "../images/allImages";

export const contentTextLinks = {
    webDesign: {
        title: "Web Design",
        subTitle:
            "We build websites that serve as powerful marketing tools and bring memorable brand experiences.",
        cards: [
            {
                id: 0,
                image: allImages.catalogImages.web_Img1,
                title: "EXPRESS",
                text: "A multi-carrier shipping website for ecommerce businesses",
            },
            {
                id: 1,
                image: allImages.catalogImages.web_Img2,
                title: "TRANSFER",
                text: "Site for low-cost money transfers and sending money within seconds",
            },
            {
                id: 2,
                image: allImages.catalogImages.web_Img3,
                title: "PHOTON",
                text: "A state-of-the-art music player with high-resolution audio and DSP effects",
            },
            {
                id: 3,
                image: allImages.catalogImages.web_Img4,
                title: "BUILDER",
                text: "Connects users with local contractors based on their location",
            },
            {
                id: 4,
                image: allImages.catalogImages.web_Img5,
                title: "BLOGR",
                text: "Blogr is a platform for creating an online blog or publication",
            },
            {
                id: 5,
                image: allImages.catalogImages.web_Img6,
                title: "CAMP",
                text: "Get expert training in coding, data, design, and digital marketing",
            },
        ],
    },
    appDesign: {
        title: "App Design",
        subTitle:
            "Our mobile designs bring intuitive digital solutions to your customers right at their fingertips.",
        cards: [
            {
                id: 0,
                image: allImages.catalogImages.app_Img1,
                title: "AIRFILTER",
                text: "Solving the problem of poor indoor air quality by filtering the air",
            },
            {
                id: 1,
                image: allImages.catalogImages.app_Img2,
                title: "EYECAM",
                text: "Product that lets you edit your favorite photos and videos at any time",
            },
            {
                id: 2,
                image: allImages.catalogImages.app_Img3,
                title: "FACEIT",
                text: "Get to meet your favorite internet superstar with the faceit app",
            },
            {
                id: 3,
                image: allImages.catalogImages.app_Img4,
                title: "TODO",
                text: "A todo app that features cloud sync with light and dark mode",
            },
            {
                id: 4,
                image: allImages.catalogImages.app_Img5,
                title: "LOOPSTUDIOS",
                text: "A VR experience app made for Loopstudios",
            },
        ],
    },
    graphicDesign: {
        title: "Graphic Design",
        subTitle:
            "We deliver eye-catching branding materials that are tailored to meet your business objectives.",
        cards: [
            {
                id: 0,
                image: allImages.catalogImages.graphic_Img1,
                title: "TIM BROWN",
                text: "A book cover designed for Tim Brown’s new release, ‘Change’",
            },
            {
                id: 1,
                image: allImages.catalogImages.graphic_Img2,
                title: "BOXED WATER",
                text: "A simple packaging concept made for Boxed Water",
            },
            {
                id: 2,
                image: allImages.catalogImages.graphic_Img3,
                title: "SCIENCE!",
                text: "A poster made in collaboration with the Federal Art Project",
            },
        ],
    },
};
